// refが指定された要素の外側がクリックされたときに、指定されたコールバック関数を呼び出すカスタムフック
// AWS authenticatorの外側をクリックするとauthenticatorが一度閉じる仕組み

import { useEffect } from 'react';

const useOutsideClick = (ref, onOutsideClick) => {
    useEffect(() => {
        // クリックイベントのハンドラー関数
        const handleClickOutside = (event) => {
             // refが存在し、かつクリックされた要素がref要素の外側にある場合
            if (ref.current && !ref.current.contains(event.target)) {
                onOutsideClick();
            }
        };
           // ドキュメント全体に対してmousedownイベントリスナーを追加
        document.addEventListener('mousedown', handleClickOutside);

        // コンポーネントがアンマウントされたときにイベントリスナーをクリーンアップ
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, onOutsideClick]);// refとonOutsideClickが変更されたときに再レンダリング

    // カスタムフックの実行結果を返す
};

export default useOutsideClick;
